import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { EscalationLevelConfig, EscalationNotificationChannels } from '../models/configuration-row';
import { SLAEscalationConfigurationSaveRequest } from '../models/sla-escalation.model';

export const EscalationConfigurationActions = createActionGroup({
  source: 'Escalation Configuration',
  events: {
    'Load Settings': emptyProps(),
    'Load Settings Success': props<{
      configurationId: number | null;
      escalationEnabled: boolean;
      escalationLevels: EscalationLevelConfig[];
    }>(),
    'Load Settings Failure': props<{ error: string }>(),
    'Save Settings': props<{ payload: SLAEscalationConfigurationSaveRequest }>(),
    'Save Settings Success': props<{
      message: string;
      configurationId: number;
      escalationEnabled: boolean;
      escalationLevels: EscalationLevelConfig[];
    }>(),
    'Save Settings Failure': props<{ error: string }>(),
    'Update Escalation Status': props<{ enabled: boolean; remarks?: string }>(),
    'Update Escalation Status Success': props<{
      message: string;
      escalationEnabled: boolean;
    }>(),
    'Update Escalation Status Failure': props<{ error: string }>(),
    'Set Escalation Enabled': props<{ enabled: boolean }>(),
    'Update Escalation Level': props<{
      levelId: string;
      changes: Partial<
        Pick<
          EscalationLevelConfig,
          'triggerPercent' | 'triggerHint' | 'escalateTo' | 'alertRecipients'
        > & {
          channels?: Partial<EscalationNotificationChannels>;
        }
      >;
    }>(),
    'Clear Error': emptyProps(),
    'Clear Success Message': emptyProps(),
  },
});
